import { render } from "./ListeTypeTaxePage.vue?vue&type=template&id=6af95621&ts=true"
import script from "./ListeTypeTaxePage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeTaxePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__